export default "__VITE_ASSET__2b740dd2__"